// extracted by mini-css-extract-plugin
export default {"content":"Board_dev_content__bk325","ref":"Board_dev_ref__Tb8uF","board-container":"Board_dev_board-container__sDUdr","content2":"Board_dev_content2__lUIfJ"};